import { AuthProvider } from './AuthProvider';

const AppProvider = ({ children }) => (
    <>
        <AuthProvider>{ children }</AuthProvider>
    </>
);

export default AppProvider;